"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawTransaction = void 0;
var buffer_1 = require("buffer");
var lodash_1 = require("lodash");
var js_sha3_1 = require("js-sha3");
var __1 = require("../..");
var Inputs_1 = require("./Inputs");
var Outputs_1 = require("./Outputs");
var ContractOption_1 = require("./ContractOption");
var RawWitnesses_1 = require("./RawWitnesses");
var EmptyPKWitness_1 = require("../Types/RawWitness/EmptyPKWitness");
var PKWitness_1 = require("../Types/Witness/PKWitness");
var Witness_1 = require("../Types/Witness/Witness");
var Serialization_1 = require("../../Handlers/Serialization");
var RawTransaction = /** @class */ (function () {
    function RawTransaction(version, inputs, outputs, contract, witnesses) {
        this.version = version;
        this.inputs = inputs;
        this.outputs = outputs;
        this.contract = new ContractOption_1.ContractOption(contract);
        if (lodash_1.isUndefined(witnesses)) {
            this.rawWitnesses = new RawWitnesses_1.RawWitnesses([]);
        }
        else {
            this.rawWitnesses = witnesses;
        }
        if (this.contract) {
            this.contract = new ContractOption_1.ContractOption(contract);
        }
        else {
            this.contract = new ContractOption_1.ContractOption();
        }
    }
    RawTransaction.read = function (buffer, offset, full) {
        var version = buffer.readUInt32BE(offset);
        offset += 4;
        var _a = Inputs_1.Inputs.read(buffer, offset), inputs = _a.inputs, inputs_offset = _a.offset;
        offset = inputs_offset;
        var _b = Outputs_1.Outputs.read(buffer, offset), outputs = _b.outputs, outputs_offset = _b.offset;
        offset = outputs_offset;
        var _c = ContractOption_1.ContractOption.read(buffer, offset), contractOption = _c.contractOption, contractOption_offset = _c.offset;
        offset = contractOption_offset;
        var _d = RawWitnesses_1.RawWitnesses.read(buffer, offset, full), rawWitnesses = _d.rawWitnesses, witnesses_offset = _d.offset;
        offset = witnesses_offset;
        var rawTx = new RawTransaction(version, inputs, outputs, contractOption.contract, rawWitnesses);
        return { rawTx: rawTx, offset: offset };
    };
    RawTransaction.fromHex = function (hex, full) {
        if (full === void 0) { full = true; }
        var buffer = buffer_1.Buffer.from(hex, 'hex');
        var rawTx = RawTransaction.read(buffer, 0, full).rawTx;
        return rawTx;
    };
    RawTransaction.prototype.getSize = function (full) {
        var inputsSize = this.inputs.getSize();
        var outputsSize = this.outputs.getSize();
        var witnessesSize = this.rawWitnesses.getSize(full);
        var contractSize = this.contract.getSize();
        return 4 + inputsSize + outputsSize + witnessesSize + contractSize;
    };
    RawTransaction.prototype.write = function (buffer, offset, full) {
        offset = buffer.writeUInt32BE(this.version, offset);
        offset = this.inputs.write(buffer, offset);
        offset = this.outputs.write(buffer, offset);
        offset = this.contract.write(buffer, offset);
        offset = this.rawWitnesses.write(buffer, offset, full);
        return offset;
    };
    RawTransaction.prototype.serialize = function (full) {
        var size = this.getSize(full);
        var buffer = buffer_1.Buffer.alloc(size);
        this.write(buffer, 0, full);
        return buffer;
    };
    RawTransaction.prototype.toHex = function (full) {
        if (full === void 0) { full = true; }
        return this.serialize(full).toString('hex');
    };
    RawTransaction.prototype.toJson = function () {
        return {
            version: this.version,
            inputs: this.inputs.toJson(),
            outputs: this.outputs.toJson(),
            witnesses: this.rawWitnesses.toJson(),
            contract: this.contract.toJson()
        };
    };
    RawTransaction.prototype.toApiJson = function () {
        var _a;
        /// TODO: Witness
        return _a = {},
            _a[this.hash().toString()] = {
                version: this.version,
                inputs: this.inputs.inputs.map(function (input) { return input.toApiJson(); }),
                outputs: this.outputs.outputs.map(function (output) { return output.toApiJson(); }),
                contract: this.contract.contract ? this.contract.contract.toJson() : undefined
            },
            _a;
    };
    RawTransaction.prototype.hash = function () {
        var buffer = this.serialize(false);
        return new __1.Hash(js_sha3_1.sha3_256(buffer));
    };
    RawTransaction.prototype.signRawWitnesses = function (mnemonic) {
        var _this = this;
        var txHash = js_sha3_1.sha3_256(this.serialize(false));
        var getWitnessesHash = function () {
            var buffer = buffer_1.Buffer.alloc(Serialization_1.getSizeOfVarInt(_this.rawWitnesses.rawWitnesses.length) + lodash_1.sumBy(_this.rawWitnesses.rawWitnesses, function (rawWitnesses) { return rawWitnesses.getSize(); }));
            var offset = 0;
            offset = Serialization_1.writeVarInt(_this.rawWitnesses.rawWitnesses.length, buffer, offset);
            _this.rawWitnesses.rawWitnesses.forEach(function (rawWitnesses) { return offset = rawWitnesses.write(buffer, offset); });
            return js_sha3_1.sha3_256(buffer);
        };
        var zenKey = __1.ExtendedKey.fromMnemonic(mnemonic, "pair");
        var derivedKey;
        var publicKey;
        var newRWs = [];
        for (var _i = 0, _a = this.rawWitnesses.rawWitnesses; _i < _a.length; _i++) {
            var rw = _a[_i];
            if (rw instanceof EmptyPKWitness_1.EmptyPkWitness) {
                derivedKey = zenKey.derivePath(rw.keyPath);
                publicKey = derivedKey.getPublicKey();
                if (publicKey.toString() === __1.PublicKey.deserialize(rw.publicKey).toString()) {
                    var msg = rw.sigHash == Witness_1.SigHash.FollowingWitnesses ? __1.Hash.computeMultiples([txHash, getWitnessesHash()]).hash : txHash;
                    newRWs.push(new PKWitness_1.PKWitness(rw.sigHash, rw.publicKey, derivedKey.getPrivateKey().sign(buffer_1.Buffer.from(msg, 'hex')).serialize()));
                }
                else {
                    newRWs.push(rw);
                }
            }
        }
        this.rawWitnesses.rawWitnesses = newRWs;
        return this;
    };
    return RawTransaction;
}());
exports.RawTransaction = RawTransaction;
//# sourceMappingURL=RawTransaction.js.map